import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative py-48"
}
const _hoisted_2 = {
  key: 1,
  class: "max-w-7xl mx-auto p-8"
}
const _hoisted_3 = { class: "grid grid-cols-2 gap-8 md:grid-cols-4" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 2,
  class: "py-12 text-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl text-gray-bluer-500 dark:text-gray-blue-100" }, "Oh no!", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-8 max-w-sm leading-none mx-auto mt-2 text-gray-bluer-100" }, "There are currently no brands on the system. You cannot add offers when there are no brands.", -1)

import { onMounted, ref, computed } from "vue";
import { useStore }                 from "vuex";
import { api as Api }               from "@greywind/common";
import {
    AppLoader as Loader,
    AppErrorEmpty as Empty
}                                   from "@greywind/ui";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const activeEnvironment = computed( () => store.getters[ "auth/activeEnvironment" ] );
const brands       = ref( [] );
const loading      = ref( true );

onMounted( async (): Promise<void> => {
    await store.dispatch( "title/setContents", "Dashboard" );

    const { data }: { data: any } = await Api.request( 'get', 'denfield-app-user/denfield-package-automotive/brands', {}, activeEnvironment.value.meta.api.url );

    brands.value = data.data || [];

    loading.value = false;
} );


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Loader), {
            class: "text-theme",
            "background-colour": "bg-white dark:bg-gray-bluer-600"
          })
        ]))
      : (brands.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brands.value, (brand, i) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: i,
                  to: { name: 'Ranges', params: { brand: brand.id } },
                  class: "col-span-1 flex justify-center py-4 px-8 rounded-lg bg-gray-blue-100 dark:bg-gray-bluer-400 hover:ring-2 hover:ring-theme"
                }, {
                  default: _withCtx(() => [
                    (brand.logo && brand.logo.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "max-h-24",
                          src: brand.logo.url,
                          alt: brand.name
                        }, null, 8, _hoisted_4))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          innerHTML: brand.name
                        }, null, 8, _hoisted_5))
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createVNode(_unref(Empty), { class: "w-1/2 mx-auto dark:text-gray-blue-500" })
          ]))
  ]))
}
}

})